<template>
  <div class="overlive-btn" @click="clickEvent">
    已结束
  </div>
</template>

<script>
  export default {
    methods: {
      clickEvent: function (){
        this.$emit('click')
      }
    }
  }
</script>

<style>
  .overlive-btn{
    width: 100px;
    height: 28px;
    border-radius: 14px;
    background: #eaeaea;
    color: #9e9e9e;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/live/button/overlive_btn.vue